import {Button} from '../../Components/Button/Button'
import './Login.scss'
import {useState} from 'react'
import {useLocalization} from '../../Hooks/useLocalization'
import {TextInput} from '../../Components/TextInput/TextInput'
import {isValidEmail} from '../../Utils/Validations'
import {store} from "../../Store/Store";
import {setJwt} from "../../Store/AuthenticationSlice";
import {setDestinationView} from "../../Store/InterfaceSlice";
import {useDispatch} from "react-redux";

export function Login() {
    const localization = useLocalization('login')
    const [email, setEmail] = useState('')
    const [code, setCode] = useState('')

    const setCodeTrimmed = (code: string) => { setCode(code.trim()) }

    const [loginEmailSend, setLoginEmailSend] = useState(false);

    const dispatch = useDispatch();

    const login = () => {
        fetch(
            `https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/login`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email
                }),
            }
        ).catch((err) => {
            console.warn(`fetch login failed: `, err)
        })

        setLoginEmailSend(true)
    }

    const checkCode = () => {
        fetch(
            'https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/login-check-code',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    code: code
                }),
            }
        ).then(resp => {

            resp.json().then(data => {
                if (data.token != null) {
                    setTimeout(() => {
                        store.dispatch(setJwt(data?.token));
                        dispatch(
                            setDestinationView({
                                destinationView: 'certificate-list',
                            })
                        );
                    }, 1);

                }
            }).catch((err) => {
                console.warn(`fetch login failed: `, err)
            });


        }).catch((err) => {
            console.warn(`fetch login failed: `, err)
        });

    }

    return (
        <div className="login">
            {loginEmailSend ? (
                <>
                    <TextInput
                        label={localization.text('login-code', 'Login code')}
                        value={code}
                        onChange={setCodeTrimmed}
                        isValid={code == '' || code.length === 6}
                    />
                    {code ? (
                        <Button
                            importance={'primary'}
                            text={localization.text('login-button', 'Inloggen')}
                            onClick={checkCode}
                        />
                    ) : null}
                </>
            ) : (
                <>
                    <TextInput
                        label={localization.text('login-email', 'Login email')}
                        value={email}
                        onChange={setEmail}
                        isValid={!email || isValidEmail(email)}
                    />
                    {email && isValidEmail(email) ? (
                        <Button
                            importance={'primary'}
                            text={localization.text('login-code-button', 'Code versturen')}
                            onClick={login}
                        />
                    ) : null}
                </>
            )}
        </div>
    )
}
